<template>
  <div ref="subjectSwipe" class='swipe-wrap' v-if="bannerUrl">
    <ul class="flex-default">
      <li class="swipe-item" v-for="item in bannerUrl" :key="item.url">
        <img :src="item.url" alt="">
        <div class="des ellipsis">{{item.dec}}</div>
      </li>
      <li class="more">查<br/>看<br/>更<br/>多<br/>></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    bannerUrl:Array
  },
  data() { return {

  } },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this._initScroll()
    });
  },
  methods: {
    _initScroll() {
      this.swipeScroll = new this.$BScroll(this.$refs.subjectSwipe, {
        click: true,
        scrollX: true,
        freeScroll: true,
        eventPassthrough: 'vertical'
      });
    }
  },
  filters: {},
  components: {}
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~src/stylus/reset"
.swipe-wrap 
  // box-shadow: 0px 4px 6px 0px rgba(230, 230, 230, 0.5);
  width 690px
  height 400px
  display block
  ul
    width -webkit-min-content
    width -moz-min-content
    width fit-content
    box-sizing border-box
    white-space nowrap
    li 
      width 600px
      height 400px
      font-size 34px
      margin-right 6px
      border-radius 10px
      box-shadow: 0px 4px 6px 0px rgba(230, 230, 230, 0.5)
      img 
        width 100%
        height 300px
        border-radius 8px 8px 0 0
      .des  
        padding 0 26px
        font-size 34px
        color #000
        line-height 100px
      &.more
        padding-top 70px
        width 100px
        height 330px
        color #000
        line-height 50px
        text-align center
</style>



// WEBPACK FOOTER //
// com-list-swipe.vue?523e6691